// src/utils/languageMigration.ts

/**
 * Migration pour forcer tous les utilisateurs au français par défaut
 * Cette migration s'exécute une seule fois au chargement de l'app
 */

const MIGRATION_KEY = 'languageMigration_v1';
const DUTCH_REGION_MIGRATION_KEY = 'languageMigration_nlRegional_v1';
const LANGUAGE_KEY = 'preferredLanguage';

export const migrateToFrenchDefault = (): void => {
    try {
        // Vérifier si la migration a déjà été exécutée
        const migrationDone = localStorage.getItem(MIGRATION_KEY);
        
        if (!migrationDone) {
            // #1452 : ne plus écraser preferredLanguage en fr — la détection i18n
            // (querystring lang > localStorage > navigator > fallback fr) prend le relais.
            localStorage.setItem(MIGRATION_KEY, 'completed');
        }

        // Legacy UI `nl` → Flandre `nl-BE` (ne pas confondre avec Pays-Bas `nl-NL`)
        if (!localStorage.getItem(DUTCH_REGION_MIGRATION_KEY)) {
            const current = localStorage.getItem(LANGUAGE_KEY);
            if (current === 'nl') {
                localStorage.setItem(LANGUAGE_KEY, 'nl-BE');
            }
            localStorage.setItem(DUTCH_REGION_MIGRATION_KEY, 'completed');
        }
    } catch (error) {
        console.error('❌ Erreur lors de la migration de langue:', error);
    }
};
